import { render, staticRenderFns } from "./Promoter.vue?vue&type=template&id=1ee11dda&scoped=true"
import script from "./Promoter.vue?vue&type=script&lang=js"
export * from "./Promoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee11dda",
  null
  
)

export default component.exports